import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const unLocodeSchema: CollectionCreateSchema = {
  name: CollectionName.UnLocode,
  fields: [
    {
      name: "country_code",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "country",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "location_code",
      type: "string",
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "location",
      type: "string",
      facet: true,
      infix: true,
      sort: true,
    },
    {
      name: "code",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
